// Deprecated: constants moved to API-driven enums. Keep this file as a minimal placeholder
// to avoid breaking imports during migration. Do not add new constants here.

export const DEPRECATED_CONSTANTS_REMOVED = true;

export const DEFAULT_CACHE_TIME = 10; // 10 milliseconds

export const USER_ROLES = [
  { value: "Super", label: "Super Admin" },
  { value: "Admin", label: "Admin" },
  { value: "Employee", label: "Employee" },
  { value: "Finance", label: "Finance" },
  { value: "User", label: "User" },
  { value: "PowerBiAdmin", label: "Power BI Admin" },
  { value: "PowerBiUser", label: "Power BI User" },
];

export const EMPLOYEE_ROLES = [
  "Team Member",
  "Sales Representative",
  "Manager",
  "Technical Lead",
  "Developer",
  "Qualifier",
  "Designer",
  "Project Manager",
  "Assistant Project Manager",
  "content Writer",
  "Account Manager",
  "Business Development Manager",
  "Campaign Supervisor",
  "Chaperon",
  "Client Referrer",
  "Junior Developer",
  "Lead Gen Strategist",
  "Lead Strategist",
  "Onboarding",
  "Online Marketing Consultant",
  "Partnership Development",
  "PPC Associate",
  "PPC Manager",
  "Senior Developer",
];

export const VENDOR_CATEGORY_OPTIONS = [
  { label: "Technology", value: "Technology" },
  { label: "Design", value: "Design" },
  { label: "Marketing", value: "Marketing" },
];

export const COMMISSION_EARNING_STATUSES = {
  ELIGIBLE: "Eligible",
  PARTIALLY_AVAILABLE: "Partially Available",
  FULLY_AVAILABLE: "Fully Available",
  PARTIALLY_PAID: "Partially Paid",
  FULLY_PAID: "Fully Paid",
};
